<template>
<div>
    <template v-if="!isDialog">
        <component :orderDetail="orderDetail" :is="operate" v-model="statusForm" :sampleRecollectTimes="testTimes+1" :sampleId="sampleId" :currentSampleId="currentSampleId" ref="operate" v-if="showHandleComponent" @closeDialog="close" :labOrderId="labOrderId" :isAgentOrder="isAgentOrder"></component>
    </template>
  <el-dialog v-else :visible.sync="dialogVisible" width="28%" :append-to-body="true" :before-close="close" class="order-handle-dialog" v-loading="loading" :close-on-click-modal="false">
    <p slot="title" class="dialog-title">{{title}}</p>
    <component :is="operate" v-model="statusForm" :sampleId="sampleId" :sampleRecollectTimes="testTimes"  ref="operate" v-if="showHandleComponent" @closeDialog="close"></component>
    <p v-else>{{commonTip}}</p>
    <div class="buttons">
        <el-button type="primary" @click="certain">确&nbsp;&nbsp;认</el-button>
        <el-button type="primary" plain @click="close">取&nbsp;&nbsp;消</el-button>
    </div>
  </el-dialog>
</div>

</template>

<script>
// 组件class前缀
import WAITING_SAMPLE_RECOLLECT from './operate/WAITING_SAMPLE_RECOLLECT'
import SAMPLE_RECOLLECT from './operate/SAMPLE_RECOLLECT'
import MUTATION_VERIFICATION from './operate/MUTATION_VERIFICATION'
// 成人样本接收专有
import CONTINUE from './operate/CONTINUE'
import { handle } from 'cps/lab-order/order-status/status'
import { formatActionAcceptableResult } from 'enumeration/lab-order.js'
const prefixCls = 'order-handle-dialog'
export default {
  name: 'order-handle-dialog',
  props: {
    task: {
      type: Object
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 关闭的回掉
    handleClose: {
      type: Function
    },
    operate: {
      type: String // 重采'LAB_SAMPLE_RETURNED'，上传突变验证报告'MUTATION_REPORT'
    },
    title: {
      type: String
    },
    handleSubmit: {
      type: Function
    },
    isDialog: {
      type: Boolean,
      default: true
    },
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    WAITING_SAMPLE_RECOLLECT,
    MUTATION_VERIFICATION,
    SAMPLE_RECOLLECT,
    CONTINUE
  },
  data () {
    return {
      visible: this.dialogVisible,
      statusForm: {
      },
      loading: false
    }
  },
  computed: {
    testTimes () {
      return this.task && this.task.orderActionData && this.task.orderActionData.order && this.task.orderActionData.order.samples.length
    },
    sampleId () {
      return this.task && this.task.orderActionData && this.task.orderActionData.order.samples[0].sampleId
    },
    currentSampleId () {
      return this.task && this.task.orderActionData && this.task.orderActionData.order.sampleId
    },
    labOrderId () {
      return this.task && this.task.orderId
    },
    classes () {
      return `${prefixCls}`
    },
    commonTip () {
      return `该订单将进行${formatActionAcceptableResult(this.operate)},是否继续？`
    },

    showHandleComponent () {
      if (this.operate === 'CONTINUE') {
        if (this.isAdult && (this.task.orderActionData.action === '样本接收' || this.task.orderActionData.action === 'LAB_SAMPLES_RECEIVED') && this.operate === 'CONTINUE') {
          return true
        }
        return false
      }

      return !!this.$options.components[this.operate]
    },
    data () {
      let file = this.statusForm.file
      let res = {
        statusResult: this.operate,
        taskId: this.task.id
      }
      let sampleRecollectCost = this.statusForm.sampleRecollectCost
      // 上传突变验证
      if (file) {
        res.file = file
        res.attachment = {
          type: 'VERIFICATION_REQUEST',
          name: file.name
        }
      }
      // 重采
      if (sampleRecollectCost) {
        res.sampleRecollectCost = Number(sampleRecollectCost) * 100// 重采
      }
      // 成人实验室样本接收
      if (this.statusForm.labCode) {
        res.labCode = this.statusForm.labCode
      }
      console.log('res', res)
      return res
    },
    isAgentOrder () {
      return this.task && this.task.orderActionData && this.task.orderActionData.order && this.task.orderActionData.order.businessFrom === 'AGENT'
    },
    isAdult () {
      return this.$route.name === 'adult-sell-order-detail' || this.$route.name === 'adult-sell-order-handle' || this.$route.query.isAdult
    }
  },
  watch: {
    task: {
      handler: function (val) {
        console.log('task', val)
      },
      immediate: true
    }
  },
  methods: {
    close (val) {
      this.handleClose && this.handleClose()
    },
    certain () {
      let formValidate = this.$refs.operate && this.$refs.operate.formValidate
      if (formValidate) {
        formValidate().then(res => {
          this.close()
          this.submit(this.data)
        })
      } else {
        this.close()
        this.submit(this.data)
      }
    },
    async submit (data) {
      try {
        // 开始处理异常订单
        this.$emit('before-submit')
        let res = await handle(data, this.isAdult)
        this.loading = false
        switch (res.type) {
          case 'error':
            this.$message.error(res.data.message)
            this.$emit('on-error', res.data)
            break
          case 'warning':
            this.$message.warning(res.data.message)
            this.$emit('on-success', res)
            break
          case 'success':
            this.$emit('on-success', res)
            break
          default:
            break
        }
      } catch (error) {
        this.$emit('on-error', error)
        console.error(error)
        this.loading = false
        /* global _ */
        let message = _.isString(error) ? error : '操作失败！'
        this.$message.error(message)
      }
    }
  }
}
</script>

<style  lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.order-handle-dialog{
  .el-dialog{
    border-radius: 10px;
    padding:30PX;
    min-width:500PX;
  }
  .dialog-title{
    font-weight: bold;
    font-size: 26PX;
    margin-top: 0;
    margin-bottom: 0;
    line-height: 0;
  }
  .buttons{
        margin-top:50px;
        .el-button{
            margin-right: 30px;
        }
    }
}
</style>
